import { TabContext, TabList } from "@mui/lab";
import { TableRow, TableCell, Avatar, Tab } from "@mui/material";
import { PublicKey } from "@solana/web3.js";
import {
  FC,
  Fragment,
  SyntheticEvent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getTreasuryTradingTable } from "../../../api/clubs/club.api";
import { bestTradingTableColumnNames } from "../../../common/constants/clubs.constants";
import { TableFilterTradingTable } from "../../../common/enums/common.enums";
import {
  ITradingTableInfo,
  ITradingInfo,
} from "../../../common/interfaces/club.interface";
import { getMintMetadata, getTrimmedPublicKey } from "../../../utils/helpers";
import BasicTable from "../../tables/BasicTable";

const BestNftTradeTable: FC<{ clubAddress: string }> = ({ clubAddress }) => {
  const [tradingTableInfo, setTradingTableInfo] = useState<ITradingTableInfo>();
  const [selectedTableInfo, setSelectedTableInfo] = useState<ITradingInfo[]>();
  const [tableTab, setTab] = useState<string>(TableFilterTradingTable.BUY);
  useEffect(() => {
    void getTreasuryTableInfo();
  }, []);

  const getTreasuryTableInfo = async () => {
    try {
      const tradingInfoDto = await getTreasuryTradingTable(clubAddress);
      const buyNfts: ITradingInfo[] = [];
      const sellNfts: ITradingInfo[] = [];

      for (const buyNft of tradingInfoDto.buys) {
        const metadata = await getMintMetadata(new PublicKey(buyNft.mint));
        buyNfts.push({
          ...buyNft,
          nftImg: metadata.image,
          nftName: metadata.name,
        });
      }

      for (const sellNft of tradingInfoDto.sells) {
        const metadata = await getMintMetadata(new PublicKey(sellNft.mint));
        sellNfts.push({
          ...sellNft,
          nftImg: metadata.image,
          nftName: metadata.name,
        });
      }
      setTradingTableInfo({
        buys: buyNfts,
        sells: sellNfts,
      });
      setSelectedTableInfo(buyNfts);
    } catch (error) {
      console.log(error);
    }
  };
  const handleChange = (
    event: SyntheticEvent,
    newValue: TableFilterTradingTable
  ) => {
    switch (newValue) {
      case TableFilterTradingTable.BUY:
        setSelectedTableInfo(tradingTableInfo?.buys);
        break;
      case TableFilterTradingTable.SELL:
        setSelectedTableInfo(tradingTableInfo?.sells);
        break;
    }
    setTab(newValue);
  };

  const renderTreasuryTradingTable = useMemo(() => {
    return selectedTableInfo?.map((row) => (
      <TableRow
        key={row.mint}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Avatar src={row.nftImg} variant="square" />
        </TableCell>
        <TableCell>{row.nftName}</TableCell>
        <TableCell>{row.price}</TableCell>
        <TableCell>{getTrimmedPublicKey(row.mint)}</TableCell>
      </TableRow>
    ));
  }, [selectedTableInfo]);

  return (
    <Fragment>
      {tradingTableInfo && renderTreasuryTradingTable && (
        <>
          <TabContext value={tableTab}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons={false}
              allowScrollButtonsMobile
            >
              {[TableFilterTradingTable.BUY, TableFilterTradingTable.SELL].map(
                (child, index) => (
                  <Tab label={child} value={child} key={index} />
                )
              )}
            </TabList>
          </TabContext>

          <BasicTable
            renderTableItems={renderTreasuryTradingTable}
            titles={bestTradingTableColumnNames}
            loader={false}
          />
        </>
      )}
    </Fragment>
  );
};

export default BestNftTradeTable;
